export default __webpack_public_path__ + "static/media/image.prime-technologies-global-pvt-ltd.d44d2c8c.png";